import { combineReducers } from 'redux'

import Layout from './layouts/reducer'

import { reducer as accordionPagination } from './accordionPagination'
import { reducer as auth } from './auth'
import { reducer as formFilters } from './formFilters'
import { reducer as modal } from './modal'
import { reducer as search } from './search'
import { reducer as table } from './table'

const rootReducer = combineReducers({
    Layout,
    formFilters,
    accordionPagination,
    search,
    modal,
    auth,
    table,
})

export default rootReducer
